import { Component, Vue } from 'vue-property-decorator';

import { LargeInlineImageBlockViewModel } from './LargeInlineImageModule.types';
import { getComponentProps } from '@/utils/vueUtils';

import ImageVideoGallery from '@/components/ImageVideoGallery/ImageVideoGallery.vue';
import { ImageSizes, ImageSize } from '@/common/interfaces/SizeBreakpoints';
import ResponsiveImage from '@/components/ResponsiveImage/ResponsiveImage.vue';
import Rectangles from '@/assets/icons/rectangles.svg?inline';

import { getResizeImage } from '@/utils/commonUtils';

const LargeInlineImageModuleProps = Vue.extend({
  props: getComponentProps<LargeInlineImageBlockViewModel>({
    Image: { Url: getResizeImage('moose.jpg'), Alt: 'Moose' },
    Gallery: {
      Slides: [
        {
          Image: { Url: '#', Alt: '#' },
          Video: {
            Type: 'video/youtube',
            Url: 'https://www.youtube.com/watch?v=2x24IDoIT40',
            Poster: getResizeImage('diving.jpg'),
          },
          Caption: '',
          Photographer: {
            PhotographerName: 'Robert Swan',
            PhotographerTitle: 'Guest',
            PhotoDate: 'May 2018',
          },
        },
      ],
      ShareData: {
        Url: 'https://d3t9z7c45vc1rg.cloudfront.net/',
        Title: '10 Tips for Better Expedition Photos',
        Description:
          'Grosvenor Teacher Fellow Cristina Veresan shares the photo lessons she learned while on expedition in Svalbard.',
        Hashtags: 'article,travel,lindblad',
        Quote: 'Lindblad article - facebook',
        TwitterUser: 'LindbladExp',
      },
    },
  }),
});

@Component({
  components: {
    ImageVideoGallery,
    ResponsiveImage,
    Rectangles,
  },
})
export default class LargeInlineImageModule extends LargeInlineImageModuleProps {
  imageSizes: ImageSizes = {
    def: new ImageSize([328, 219]),
    sizes: {
      sm: new ImageSize([498, 330]),
      md: new ImageSize([727, 409]),
      lg: new ImageSize([1128, 635]),
      xl: new ImageSize([1920, 1080]),
    },
  };
}
